import React from 'react'
import { Sunrise, EarlyBird, Cloud, Overnight } from 'pcln-icons'

export const DEFAULT_TIME_ICONS = [
  <Sunrise size={14} key='Early Morning' />,
  <EarlyBird size={14} key='Morning' />,
  <Cloud size={14} key='Afternoon' />,
  <Overnight size={14} key='Evening' />,
]

export const TIME_ICONS = {
  Sunrise: <Sunrise size={14} key='Early Morning' />,
  EarlyBird: <EarlyBird size={14} key='Morning' />,
  Cloud: <Cloud size={14} key='Afternoon' />,
  Overnight: <Overnight size={14} key='Evening' />,
}
